// import { useEffect, useRef, useState } from "react";
// import {
//   useFetchPackagingData,
//   useVerifyPackagingItem,
// } from "../../apis/packagingApis";
// import toast from "react-hot-toast";
// import LabelPrintModal from "../OrderManagement/_components/LabelPrintModal";
// import { useQueryClient } from "@tanstack/react-query";
// import AllOrders from "./_components/AllOrders";

// type Item = {
//   id: string | number;
//   sku: string;
//   image: string;
//   total: number;
//   scanned: number;
//   done: boolean;
// };

// export default function Packaging() {
//   const [awbInput, setAwbInput] = useState("");
//   const [awb, setAwb] = useState("");
//   const [sku, setSku] = useState("");
//   const [qty, setQty] = useState(1);
//   const [localItems, setLocalItems] = useState<Item[]>([]);
//   const [activeSku, setActiveSku] = useState<string | null>(null);
//   const [showPrintModal, setShowPrintModal] = useState(false);

//   const skuRef = useRef<HTMLInputElement>(null);

//   const {
//     data: packagingData,
//     error: fetchError,
//     isError: isFetchError,
//   } = useFetchPackagingData(awb);
//   const queryClient = useQueryClient();
//   const verifyMutation = useVerifyPackagingItem();

//   // Sync from API into local state
//   useEffect(() => {
//     if (packagingData?.items) {
//       setLocalItems(packagingData.items);
//     }
//   }, [packagingData]);

//   // Show error if fetch fails
//   useEffect(() => {
//     if (isFetchError && fetchError) {
//       const errorMsg =
//         (fetchError as any).response?.data?.message ||
//         fetchError.message ||
//         "Order cannot be scanned ❌";
//       toast.error(errorMsg);
//       setLocalItems([]);
//       setAwb("");
//       setAwbInput("");
//     }
//   }, [isFetchError, fetchError]);

//   useEffect(() => {
//     if (awb) skuRef.current?.focus();
//   }, [awb]);

//   useEffect(() => {
//     if (sku) {
//       const item = localItems.find((i: Item) => i.sku === sku);
//       if (item) {
//         setQty(item.scanned + 1);
//       } else {
//         setQty(1);
//       }
//     } else {
//       setQty(1);
//     }
//   }, [sku, localItems]);

//   const playBeep = () => {
//     const audio = new Audio(
//       "https://actions.google.com/sounds/v1/cartoon/wood_plank_flicks.ogg",
//     );
//     audio.play();
//   };

//   const activeItems = localItems.filter((i: Item) => !i.done);
//   const completedItems = localItems.filter((i: Item) => i.done);
//   const allDone =
//     localItems.length > 0 && localItems.every((i: Item) => i.done);

//   const handleVerify = async () => {
//     const currentAwb = awb || awbInput;
//     if (!currentAwb) {
//       toast.error("Please scan AWB first ❌");
//       return;
//     }
//     if (!sku) {
//       toast.error("Please scan SKU ❌");
//       return;
//     }

//     const index = activeItems.findIndex((i: Item) => i.sku === sku);

//     if (index === -1) {
//       if (completedItems.find((i: Item) => i.sku === sku)) {
//         toast.error("Item already fully scanned ❌");
//       } else {
//         toast.error("Invalid SKU ❌");
//       }
//       setActiveSku(null);
//       setSku("");
//       skuRef.current?.focus();
//       return;
//     }

//     const item = activeItems[index];

//     if (qty > item.total) {
//       toast.error(
//         `Cannot scan more than total quantity (${item.scanned}/${item.total}) ❌`,
//       );
//       setActiveSku(null);
//       setSku("");
//       skuRef.current?.focus();
//       return;
//     }

//     try {
//       await verifyMutation.mutateAsync({ awb: currentAwb, sku, qty });

//       // Optimistic update
//       const newScanned = qty;
//       const isDone = newScanned >= item.total;

//       setLocalItems((prev: Item[]) =>
//         prev.map((it: Item) =>
//           it.sku === sku ? { ...it, scanned: newScanned, done: isDone } : it,
//         ),
//       );

//       setActiveSku(sku);
//       playBeep();
//       toast.success("Scanned Successfully ✅");

//       if (isDone) {
//         queryClient.invalidateQueries({
//           queryKey: ["orderOperations", "PACKED"],
//         });
//       }

//       setSku("");
//       setQty(1);
//       skuRef.current?.focus();
//     } catch (error: any) {
//       toast.error(error.message || "Failed to verify item ❌");
//       setActiveSku(null);
//     }
//   };

//   const handleAwbCommit = (value: string) => {
//     const trimmed = value.trim();
//     if (trimmed) {
//       setAwb(trimmed);
//       setAwbInput(trimmed);
//       setLocalItems([]);
//     }
//   };

//   const handlePrintAwb = () => {
//     setShowPrintModal(true);
//   };

//   return (
//     <div className="">
//       <div className="bg-[#F7F6F2] px-6 py-3 w-full rounded-b-3xl">
//         {/* HEADER */}
//         <div className="mb-3 flex justify-between items-center">
//           <h1 className="text-xl font-semibold">📦 Packaging</h1>
//           <span className="text-sm text-gray-500">
//             AWB: {awb || "Not scanned"}
//           </span>
//         </div>

//         {/* SCAN BAR */}
//         <div className="sticky top-0 z-10 bg-white/90 backdrop-blur border rounded-xl shadow-sm p-4 flex items-center justify-between">
//           <div className="flex items-center gap-3">
//             <input
//               value={awbInput}
//               onChange={(e) => setAwbInput(e.target.value)}
//               onKeyDown={(e) => {
//                 if (e.key === "Enter") handleAwbCommit(awbInput);
//               }}
//               onPaste={(e) => {
//                 e.preventDefault();
//                 const pastedData = e.clipboardData.getData("Text");
//                 handleAwbCommit(pastedData);
//               }}
//               placeholder="Scan AWB"
//               className="border px-3 py-2 rounded w-full focus:ring-2 focus:ring-blue-500"
//             />

//             <input
//               ref={skuRef}
//               value={sku}
//               onChange={(e) => setSku(e.target.value)}
//               onKeyDown={(e) => e.key === "Enter" && handleVerify()}
//               placeholder="Scan SKU"
//               className="border px-3 py-2 rounded w-full text-lg font-medium tracking-wide focus:ring-2 focus:ring-blue-500"
//             />

//             <input
//               type="number"
//               value={qty}
//               readOnly
//               disabled
//               className="border px-3 py-2 rounded w-20 text-center bg-gray-100 cursor-not-allowed"
//             />
//           </div>

//           <button
//             onClick={handleVerify}
//             disabled={verifyMutation.isPending}
//             className="bg-[#FBD037] text-[#000000] px-5 py-2 rounded-lg shadow disabled:opacity-50"
//           >
//             Verify
//           </button>
//         </div>

//         {/* MAIN GRID */}
//         <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 mt-4">
//           {/* ACTIVE ITEMS + QUICK LIST */}
//           <div className="lg:col-span-3">
//             {/* QUICK LIST */}
//             <div className="bg-white rounded-xl shadow p-4">
//               <p className="font-semibold mb-3">Quick View</p>

//               {localItems.length === 0 && (
//                 <p className="text-gray-400 text-xs">No items loaded</p>
//               )}

//               {localItems.map((i: Item) => (
//                 <div
//                   key={i.id}
//                   className={`flex justify-between text-xs py-1 border-b ${
//                     i.done ? "text-green-600" : "text-gray-700"
//                   }`}
//                 >
//                   <span className={i.done ? "line-through" : ""}>{i.sku}</span>
//                   <span className="font-semibold">
//                     {i.scanned}/{i.total}
//                     {i.done && " ✔"}
//                   </span>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* COMPLETED PANEL */}
//           <div className="bg-white rounded-xl shadow p-4 h-fit">
//             <h3 className="font-semibold mb-3">
//               Completed ({completedItems.length}/{localItems.length})
//             </h3>

//             {completedItems.length === 0 ? (
//               <p className="text-gray-400 text-xs">No completed items</p>
//             ) : (
//               <div className="space-y-2">
//                 {completedItems.map((item: Item) => (
//                   <div
//                     key={item.id}
//                     className="flex items-center justify-between text-xs border-b pb-1"
//                   >
//                     <span>{item.sku}</span>
//                     <span className="text-green-600 font-bold">✔</span>
//                   </div>
//                 ))}
//               </div>
//             )}

//             {allDone && (
//               <div className="mt-4 pt-4 border-t border-gray-100">
//                 <button
//                   onClick={handlePrintAwb}
//                   className="w-full bg-[#FBD037] hover:bg-[#eac02c] text-black font-semibold py-2 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors shadow-sm"
//                 >
//                   🖨️ Print AWB
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//       <LabelPrintModal
//         open={showPrintModal}
//         onClose={() => setShowPrintModal(false)}
//         order={packagingData}
//       />

//       {/* PACKED ORDERS TABLE */}
//       <div className="mt-8">
//         <AllOrders />
//       </div>
//     </div>
//   );
// }

import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  useFetchPackagingData,
  useVerifyPackagingItem,
  useInstantScanAll,
  useFetchPackagingStaff,
  useFetchTodayPackedStream,
} from "../../apis/packagingApis";
import toast from "react-hot-toast";
import { useQueryClient } from "@tanstack/react-query";
import { usePermission } from "../../hooks/usePermissionTabs";
import LabelPrintModal from "../OrderManagement/_components/LabelPrintModal";
import AllOrders from "./_components/AllOrders";
import {
  IconBox,
  IconEye,
  IconPointFilled,
  IconPrinter,
  IconPlus,
  IconTrash,
  IconCheck,
  IconWeight,
  IconAlertTriangle,
} from "@tabler/icons-react";
import NewSelectInput from "../../components/NewSelectInput";
import { T, useLanguage } from "../../context/LanguageContext";

type Item = {
  id: string | number;
  sku: string;
  image?: string;
  itemName?: string;
  total: number;
  scanned: number;
  done: boolean;
  weight?: number;
};

export const DockStation = [
  { id: "1", value: "Dock 1", text: "Dock 1" },
  { id: "2", value: "Dock 2", text: "Dock 2" },
  { id: "3", value: "Dock 3", text: "Dock 3" },
];

type PackedEntry = {
  awb: string;
  boxName: string;
  weight: number;
  timestamp: string;
};

type PackagingProps = {
  setHeaderActions?: (node: React.ReactNode) => void;
  setHeaderButtons?: (node: React.ReactNode) => void;
};

export default function Packaging({
  setHeaderActions,
  setHeaderButtons,
}: PackagingProps) {
  const { allowed: canUpdateOrder } = usePermission("orders", "update");
  const { t } = useLanguage();
  const profile = useSelector((state: any) => state.auth.profile);
  const currentUserId = profile?.id || "";

  const [awbInput, setAwbInput] = useState("");
  const [awb, setAwb] = useState("");
  const [sku, setSku] = useState("");
  const [qty, setQty] = useState(1);
  const [localItems, setLocalItems] = useState<Item[]>([]);
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [selectedBoxId, setSelectedBoxId] = useState<string>("");
  const [lastSyncedAwb, setLastSyncedAwb] = useState<string>("");
  const [packedAwbs, setPackedAwbs] = useState<PackedEntry[]>([]);
  const [isConfirmAllModalOpen, setIsConfirmAllModalOpen] = useState(false);

  const [selectedStaffId, setSelectedStaffId] = useState<string>("");

  // Set default selected user to logged-in user
  useEffect(() => {
    if (currentUserId && !selectedStaffId) {
      setSelectedStaffId(currentUserId);
    }
  }, [currentUserId, selectedStaffId]);

  const { data: staffData = [] } = useFetchPackagingStaff();
  const { data: todayPackedStream = [] } =
    useFetchTodayPackedStream(selectedStaffId);

  const [isAwbHighlighted, setIsAwbHighlighted] = useState(false);
  const awbInputRef = useRef<HTMLInputElement>(null);
  const skuRef = useRef<HTMLInputElement>(null);
  const {
    data: packagingData,
    error: fetchError,
    isError: isFetchError,
  } = useFetchPackagingData(awb);
  const queryClient = useQueryClient();
  const verifyMutation = useVerifyPackagingItem();
  const instantScanAllMutation = useInstantScanAll();

  // Sync API data to local checklist
  useEffect(() => {
    if (packagingData) {
      setLocalItems(packagingData.items || []);

      const boxIdToUse = packagingData.selectedBoxId || "";
      setSelectedBoxId(boxIdToUse);
      setLastSyncedAwb(packagingData.awb || awb);
    } else {
      setLocalItems([]);
      setSelectedBoxId("");
      setLastSyncedAwb("");
    }
  }, [packagingData]);

  // Show error if fetch fails
  useEffect(() => {
    if (isFetchError && fetchError) {
      toast.error((fetchError as any).message || "Order cannot be scanned ❌");
      setLocalItems([]);
      setSelectedBoxId("");
      setLastSyncedAwb("");
      setAwb("");
      setAwbInput("");
    }
  }, [isFetchError, fetchError]);

  useEffect(() => {
    if (awb) skuRef.current?.focus();
  }, [awb]);

  // Update verification qty based on scanned SKU items
  useEffect(() => {
    if (sku) {
      const item = localItems.find((i) => i.sku === sku);
      if (item) {
        setQty(item.scanned + 1);
      } else {
        setQty(1);
      }
    } else {
      setQty(1);
    }
  }, [sku, localItems]);

  const playBeep = () => {
    const audio = new Audio(
      "https://actions.google.com/sounds/v1/cartoon/wood_plank_flicks.ogg",
    );
    audio.play().catch(() => {});
  };

  const activeItems = localItems.filter((i) => !i.done);
  const completedItems = localItems.filter((i) => i.done);
  const allDone = localItems.length > 0 && localItems.every((i) => i.done);

  const handleInstantScanAll = () => {
    const currentAwb = awb || awbInput;
    if (!currentAwb) {
      toast.error("No active shipment loaded ❌");
      return;
    }

    setIsConfirmAllModalOpen(true);
  };

  const handleConfirmInstantScanAll = async () => {
    const currentAwb = awb || awbInput;
    if (!currentAwb) {
      toast.error("No active shipment loaded ❌");
      return;
    }

    try {
      const response = await instantScanAllMutation.mutateAsync({
        awb: currentAwb,
        boxId: selectedBoxId || null,
      });

      playBeep();
      toast.success(response?.message || "Order Packed successfully! 🎉");
      setIsConfirmAllModalOpen(false);

      const boxType = packagingData?.boxes?.find(
        (b: any) => b.id === selectedBoxId,
      );
      const boxName = boxType?.name || "";
      const totalWeight = packagingData?.totalWeight || 0;
      const timestamp = new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
      setPackedAwbs((prev) => {
        if (!prev.find((e) => e.awb === currentAwb)) {
          return [
            ...prev,
            { awb: currentAwb, boxName, weight: totalWeight, timestamp },
          ];
        }
        return prev;
      });
    } catch (err: any) {
      toast.error(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to instant scan all items ❌",
      );
    }
  };

  const handleVerify = async () => {
    const currentAwb = awb || awbInput;
    if (!currentAwb || !sku) {
      toast.error(
        !currentAwb ? "Please scan AWB first ❌" : "Please scan SKU ❌",
      );
      return;
    }

    const item = activeItems.find((i) => i.sku === sku);
    if (!item) {
      toast.error(
        completedItems.find((i) => i.sku === sku)
          ? "Item already fully scanned ❌"
          : "Invalid SKU ❌",
      );
      setSku("");
      skuRef.current?.focus();
      return;
    }

    const itemWeight = parseFloat((item as any).weight || 0);

    // Weight capacity validation if box is selected
    if (selectedBoxId) {
      const selectedBoxType = packagingData?.boxes?.find(
        (b: any) => b.id === selectedBoxId,
      );
      if (selectedBoxType) {
        const boxCapacity = parseFloat(selectedBoxType.weight || 0) || 5.0;
        const currentScannedWeight = localItems.reduce(
          (sum, it) => sum + it.scanned * (it.weight || 0),
          0,
        );
        if (currentScannedWeight + itemWeight > boxCapacity) {
          toast.error(
            `❌ Box weight limit exceeded! Max capacity: ${boxCapacity.toFixed(2)}kg, current: ${currentScannedWeight.toFixed(2)}kg, item: ${itemWeight.toFixed(2)}kg.`,
          );
          setSku("");
          skuRef.current?.focus();
          return;
        }
      }
    }

    if (qty > item.total) {
      toast.error(
        `Cannot scan more than total quantity (${item.scanned}/${item.total}) ❌`,
      );
      setSku("");
      skuRef.current?.focus();
      return;
    }

    try {
      const response = await verifyMutation.mutateAsync({
        awb: currentAwb,
        sku,
        qty,
        boxId: selectedBoxId || null,
      });

      // Update checklist
      setLocalItems((prev) =>
        prev.map((it) =>
          it.sku === sku ? { ...it, scanned: qty, done: qty >= it.total } : it,
        ),
      );

      playBeep();

      if (response?.data?.isCompleted) {
        toast.success("Order Packed successfully! 🎉");
        const boxType2 = packagingData?.boxes?.find(
          (b: any) => b.id === selectedBoxId,
        );
        const boxName2 = boxType2?.name || "";
        const totalWeight2 = packagingData?.totalWeight || 0;
        const timestamp2 = new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        });
        setPackedAwbs((prev) => {
          if (!prev.find((e) => e.awb === currentAwb)) {
            return [
              ...prev,
              {
                awb: currentAwb,
                boxName: boxName2,
                weight: totalWeight2,
                timestamp: timestamp2,
              },
            ];
          }
          return prev;
        });
      } else {
        toast.success("Scanned Successfully ✅");
      }

      queryClient.invalidateQueries({
        queryKey: ["orderOperations"],
      });

      setSku("");
      setQty(1);
      skuRef.current?.focus();
    } catch (error: any) {
      toast.error(error.message || "Failed to verify item ❌");
    }
  };

  const handleBoxChange = async (newBoxId: string) => {
    setSelectedBoxId(newBoxId);

    const currentAwb = awb || awbInput;
    if (currentAwb) {
      try {
        await verifyMutation.mutateAsync({
          awb: currentAwb,
          sku: "",
          qty: 0,
          boxId: newBoxId || null,
        });
        toast.success("Box updated successfully ✅");
      } catch (error: any) {
        toast.error(error.message || "Failed to update box ❌");
      }
    }
  };

  const handleAwbCommit = (value: string) => {
    const trimmed = value.trim();
    if (trimmed) {
      setAwb(trimmed);
      setAwbInput(trimmed);
    }
  };

  const handlePrintAwb = () => {
    setShowPrintModal(true);
  };

  // Calculate box suggestions
  const totalOrderWeight = packagingData?.totalWeight || 0;
  const suggestedBoxCapacity =
    parseFloat(packagingData?.suggestedBox?.weight || 0) || 5.0;
  const boxesRequired =
    suggestedBoxCapacity > 0
      ? Math.ceil(totalOrderWeight / suggestedBoxCapacity)
      : 1;

  return (
    <div className="">
      <div className="  p-2  bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl transition-all duration-300 rounded-r-3xl rounded-bl-3xl w-full">
        <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* Main workspace section */}
          <div className="lg:col-span-8 space-y-6">
            {/* Scan workstation header */}
            <div className="bg-white rounded-2xl shadow-sm border p-4 md:p-6">
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 w-full sm:w-auto">
                  <h1 className="text-lg font-semibold flex items-center gap-2 whitespace-nowrap">
                    📦 {t("Packaging Workstation")}
                  </h1>
                  <NewSelectInput
                    name="dockStation"
                    placeholder={t("Select Dock Station")}
                    selectOptions={
                      DockStation?.map((acc: any) => ({
                        id: acc?.id,
                        value: acc?.value,
                        text: acc?.text,
                      })) || []
                    }
                  />
                </div>
                <div className="flex items-center gap-2 text-sm shrink-0">
                  <span className="text-[#212121]">{t("Status")}</span>
                  <button className="font-medium px-2 py-1 bg-green-100 border border-green-200 rounded-full text-green-600 flex items-center">
                    <IconPointFilled className="animate-pulse" /> {t("Online")}
                  </button>
                </div>
              </div>

              {/* Scanning inputs */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-6 gap-4">
                <div className="space-y-2 col-span-1 md:col-span-2">
                  <label className="text-xs text-gray-500">
                    {t("1. Scan AWB / Consignment No")}
                  </label>
                  <input
                    ref={awbInputRef}
                    value={awbInput}
                    onChange={(e) => setAwbInput(e.target.value)}
                    onKeyDown={(e) =>
                      e.key === "Enter" && handleAwbCommit(awbInput)
                    }
                    onPaste={(e) => {
                      e.preventDefault();
                      handleAwbCommit(e.clipboardData.getData("Text"));
                    }}
                    placeholder={t("e.g. OBP100000066")}
                    className={`w-full border rounded-lg px-4 py-2 text-sm outline-none transition-all duration-300 ${
                      isAwbHighlighted
                        ? "bg-yellow-50 border-yellow-400 ring-4 ring-yellow-400/30 scale-[1.02]"
                        : "focus:ring-1 focus:ring-yellow-400"
                    }`}
                  />
                </div>

                <div className="space-y-2 col-span-1 md:col-span-2">
                  <label className="text-xs text-gray-500">
                    {t("2. Scan Item SKU")}
                  </label>
                  <input
                    ref={skuRef}
                    value={sku}
                    onChange={(e) => setSku(e.target.value)}
                    disabled={
                      !packagingData ||
                      packagingData.status === "PACKED" ||
                      packagingData.status === "DAMAGE"
                    }
                    onKeyDown={(e) => e.key === "Enter" && handleVerify()}
                    placeholder={t("e.g. TS-BLK-M")}
                    className="w-full border rounded-lg px-4 py-2 text-sm focus:ring-1 outline-none focus:ring-yellow-400 disabled:bg-gray-100 disabled:cursor-not-allowed"
                  />
                </div>

                <div className="space-y-2 col-span-1 md:col-span-1">
                  <label className="text-xs text-gray-500">{t("Scan Qty")}</label>
                  <input
                    type="number"
                    value={qty}
                    disabled
                    readOnly
                    className="cursor-not-allowed w-full border rounded-lg px-4 py-2 text-sm focus:ring-1 outline-none focus:ring-yellow-400 bg-gray-50"
                  />
                </div>

                <div className="space-y-2 md:space-y-3 col-span-1 md:col-span-1">
                  <div className="text-xs invisible hidden md:block">
                    Button
                  </div>
                  <div className="flex items-center gap-2">
                    <button
                      onClick={handleVerify}
                      disabled={
                        verifyMutation.isPending ||
                        !packagingData ||
                        packagingData.status === "PACKED" ||
                        packagingData.status === "DAMAGE"
                      }
                      className="bg-yellow-400 w-full hover:bg-yellow-500 transition-colors text-black font-semibold px-8 py-2 rounded-lg disabled:opacity-50"
                    >
                      {t("Verify")}
                    </button>
                  </div>
                </div>
              </div>

              {packagingData ? (
                <div className="mt-6 p-4 bg-[#0F172A] border border-slate-800 rounded-2xl flex flex-col md:flex-row md:items-center justify-between gap-4 shadow-2xs">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-[#FBD037] rounded-xl flex items-center justify-center text-[#0F172A] flex-shrink-0">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <line x1="6" y1="5" x2="6" y2="19" />
                        <line x1="10" y1="5" x2="10" y2="19" />
                        <line x1="14" y1="5" x2="14" y2="19" />
                        <line x1="18" y1="5" x2="18" y2="19" />
                      </svg>
                    </div>

                    <div className="space-y-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="text-[#FBD037] font-black text-sm tracking-wide">
                          AWB: {packagingData.awbNumber || awb}
                        </span>
                        <span className="px-2 py-0.5 bg-slate-800 border border-slate-700 text-slate-300 rounded-md text-[10px] font-black uppercase tracking-wider">
                          {t("client")} : {packagingData.senderName || t("Name")}
                        </span>
                        <span className="px-2 py-0.5 bg-[#FBD037]/10 border border-[#FBD037]/30 text-[#FBD037] rounded-md text-[10px] font-bold">
                          {t("Ref")}: {packagingData.referenceNumber || t("N/A")}
                        </span>
                        {packagingData.status === "PACKED" && (
                          <span className="px-2 py-0.5 bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 rounded-md text-[10px] font-bold">
                            {t("Status")}: {t("Packed")}
                          </span>
                        )}
                        {packagingData.status === "DAMAGE" && (
                          <span className="px-2 py-0.5 bg-rose-500/10 border border-rose-500/30 text-rose-400 rounded-md text-[10px] font-bold">
                            {t("Status")}: {t("Damage / Issue")}
                          </span>
                        )}
                      </div>

                      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-slate-400 text-xs font-semibold">
                        <div>
                          Route:{" "}
                          <span className="text-white font-extrabold">
                            {packagingData.routeCode || "N/A"}
                          </span>
                        </div>
                        <div>
                          Carrier:{" "}
                          <span className="text-white font-extrabold">
                            {packagingData.shippingCompany || "N/A"} (
                            {packagingData.shippingAwbNumber || "N/A"})
                          </span>
                        </div>
                        <div>
                          Dest:{" "}
                          <span className="text-white font-extrabold">
                            {packagingData.receiverCityName || "N/A"},{" "}
                            {packagingData.receiverDistrictName || ""}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center gap-2 flex-shrink-0">
                    {packagingData.status === "PACKED" ? (
                      <button
                        onClick={handlePrintAwb}
                        className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-xl text-xs font-black flex items-center gap-1.5 transition duration-150"
                      >
                        <IconPrinter size={14} /> {t("Print Shipping Label")}
                      </button>
                    ) : packagingData.status === "DAMAGE" ? (
                      <div className="text-rose-400 text-xs font-black bg-rose-500/10 border border-rose-500/30 px-3 py-1.5 rounded-lg flex items-center gap-1.5">
                        <IconAlertTriangle
                          className="animate-pulse"
                          size={14}
                        />{" "}
                        Issue: {packagingData.subStatus || "Packaging Issue"}
                      </div>
                    ) : (
                      <button
                        onClick={handleInstantScanAll}
                        disabled={!canUpdateOrder || instantScanAllMutation.isPending}
                        className="px-4 py-2 bg-[#FBD037] hover:bg-yellow-500 disabled:opacity-50 text-slate-950 rounded-xl text-xs font-black flex items-center gap-1.5 transition duration-150"
                      >
                        {t("Instant Scan All")}
                      </button>
                    )}
                  </div>
                </div>
              ) : (
                <div className="mt-6 p-4 bg-white border-2 border-dashed border-gray-200 rounded-2xl flex items-center gap-3">
                  <div className="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center text-slate-500 flex-shrink-0">
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="5" y1="6" x2="5" y2="18" />
                      <line x1="8" y1="6" x2="8" y2="18" />
                      <line x1="11" y1="6" x2="11" y2="18" />
                      <line x1="14" y1="6" x2="14" y2="18" />
                      <line x1="17" y1="6" x2="17" y2="18" />
                      <line x1="20" y1="6" x2="20" y2="18" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-slate-700 font-extrabold text-[14px]">
                      No active shipment loaded
                    </p>
                    <p className="text-xs text-slate-400 font-semibold mt-0.5">
                      {t("Please scan a consignment/AWB barcode")}
                    </p>
                  </div>
                </div>
              )}
            </div>

            {/* Checklist & Scale Integration */}
            <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
              {/* Checklist */}
              <div className="bg-white rounded-2xl shadow-sm border border-slate-200/50 overflow-hidden flex flex-col md:col-span-7">
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100 bg-white">
                  <div className="flex items-center gap-2.5 mt-2">
                    <div className="p-1.5 bg-indigo-50 border border-indigo-100 rounded-lg text-indigo-500">
                      <IconEye size={18} stroke={2.5} />
                    </div>
                    <h3 className="font-extrabold text-[#1E293B] text-[13px] tracking-tight leading-none uppercase">
                      {t("Workstation Checklist")}
                    </h3>
                  </div>
                  {awb && (
                    <span className="px-2.5 py-1 bg-slate-50 border border-slate-200/60 text-slate-700 rounded-lg text-[10px] font-bold font-mono tracking-wide">
                      {t("AWB")} : {awb}
                    </span>
                  )}
                </div>

                <div className="p-6 space-y-3.5">
                  {localItems.length === 0 ? (
                    <div className="py-8 text-center bg-slate-50/50 rounded-2xl border border-dashed border-slate-250">
                      <p className="text-slate-400 font-extrabold text-sm">
                        No items loaded
                      </p>
                      <p className="text-xs text-slate-400 font-medium mt-1">
                        Please scan an order AWB to begin checklist
                      </p>
                    </div>
                  ) : (
                    <>
                      <div className="grid grid-cols-12 px-4.5 pb-2 text-[9px] font-black text-slate-400 tracking-wider uppercase border-b border-slate-100/60 mb-1">
                        <div className="col-span-5 text-left">SKU</div>
                        <div className="col-span-4 text-center">Name (Wt)</div>
                        <div className="col-span-3 text-right">
                          Qty Verified
                        </div>
                      </div>

                      {localItems.map((item: any) => (
                        <div
                          key={item.id}
                          className={`border rounded-2xl p-4 grid grid-cols-12 items-start gap-3 transition hover:shadow-xs ${
                            item.done
                              ? "bg-green-50/40 border-green-200/80"
                              : "bg-slate-50/50 border-slate-100/80 hover:bg-slate-50/80"
                          }`}
                        >
                          <div className="col-span-5 flex flex-wrap items-start">
                            <span
                              className="px-2.5 py-1 bg-slate-200/60 text-[#1E293B] font-extrabold text-[10px] rounded-md tracking-wider uppercase break-all leading-snug"
                              title={item.sku}
                            >
                              {item.sku}
                            </span>
                          </div>

                          <div className="col-span-4 text-center">
                            <p className="text-xs font-bold text-slate-700 leading-tight">
                              {item.itemName}
                            </p>
                            <p className="text-[10px] text-gray-400 font-semibold mt-0.5">
                              Wt:{" "}
                              {item.weight != null
                                ? parseFloat(item.weight).toFixed(2)
                                : "0.00"}{" "}
                              kg
                            </p>
                          </div>

                          <div className="col-span-3 flex items-center justify-end gap-2 text-right">
                            <span className="text-sm font-black text-slate-800 font-mono">
                              {item.scanned}{" "}
                              <span className="text-slate-400 font-normal">
                                /
                              </span>{" "}
                              {item.total}
                            </span>
                            {item.done && (
                              <span className="bg-green-150 text-green-700 p-0.5 rounded-full">
                                <IconCheck size={14} stroke={3} />
                              </span>
                            )}
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </div>

              {/* Scale Integration (Digital Live) */}
              <div className="bg-white rounded-2xl shadow-sm border border-slate-200/50 overflow-hidden flex flex-col md:col-span-5">
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100 bg-white">
                  <div className="flex items-center gap-2.5 mt-2">
                    <div className="p-1.5 bg-green-50 border border-green-150 rounded-lg text-green-600 flex items-center justify-center">
                      <IconWeight size={18} stroke={2.5} />
                    </div>
                    <h3 className="font-extrabold text-[#1E293B] text-[13px] tracking-tight leading-none uppercase">
                      {t("Scale Integration (Digital Live)")}
                    </h3>
                  </div>
                  <span className="text-green-600 text-xs font-bold bg-green-50 px-2 py-1 rounded border border-green-200 flex items-center gap-1">
                    <IconPointFilled size={12} className="animate-ping" /> COM3
                  </span>
                </div>

                <div className="p-6 space-y-6 flex-1 flex flex-col justify-between">
                  <div>
                    <div className="bg-black text-white rounded-xl p-4 flex justify-between items-center">
                      <div>
                        <p className="text-xs text-gray-400 font-bold">
                          MEASURED MASS
                        </p>
                        <p className="text-xl font-bold text-green-400 font-mono">
                          {packagingData?.scannedWeight != null
                            ? parseFloat(packagingData.scannedWeight).toFixed(2)
                            : "0.00"}{" "}
                          <span className="text-base text-gray-300 font-normal">
                            /{" "}
                            {packagingData?.totalWeight != null
                              ? parseFloat(packagingData.totalWeight).toFixed(2)
                              : "0.00"}{" "}
                            kg
                          </span>
                        </p>
                      </div>
                      <div>
                        <button className="inline-block bg-green-500 text-white text-xs px-4 py-1 rounded-full font-black uppercase tracking-wider animate-pulse">
                          {t("STABLE")}
                        </button>
                      </div>
                    </div>

                    {/* Box Type Selection */}
                    <div className="mt-6 space-y-4">
                      <div className="space-y-1">
                        <label className="text-xs font-bold text-slate-500 uppercase">
                          1. Selected Packaging Box Type
                        </label>
                        <NewSelectInput
                          name="boxSelection"
                          placeholder={t("Select Box Type")}
                          value={selectedBoxId}
                          onChange={handleBoxChange}
                          disabled={
                            !packagingData ||
                            packagingData.status === "PACKED" ||
                            packagingData.status === "DAMAGE"
                          }
                          selectOptions={[
                            {
                              id: "none",
                              value: "",
                              text: "No Box / Do not apply",
                            },
                            ...(packagingData?.boxes?.map((box: any) => ({
                              id: box.id,
                              value: box.id,
                              text: `${box.name} (${box.length}x${box.width}x${box.height} cm, Max: ${box.weight}kg)`,
                            })) || []),
                          ]}
                        />
                      </div>

                      <div className="space-y-2 pt-2">
                        <p className="text-xs font-bold text-slate-550 flex items-center gap-1.5 uppercase">
                          <IconBox size={16} /> {t("Volumetric Box Suggestion")}
                        </p>

                        {packagingData?.suggestedBox ? (
                          <div className="border-2 rounded-xl p-4 border-blue-200 bg-blue-50/30 flex justify-between items-center gap-4 relative overflow-hidden">
                            <div className="space-y-1">
                              <p className="font-extrabold text-sm text-slate-800">
                                {packagingData.suggestedBox.name}
                              </p>
                              <p className="text-xs text-gray-500 font-medium">
                                Size: {packagingData.suggestedBox.length}x
                                {packagingData.suggestedBox.width}x
                                {packagingData.suggestedBox.height} cm
                              </p>
                              <p className="text-xs font-extrabold text-blue-600 mt-2 bg-blue-50 border border-blue-150 px-2 py-0.5 rounded w-fit">
                                {t("Qty Needed")}: {boxesRequired} {t("Box(es)")}
                              </p>
                            </div>
                            <div className="text-right space-y-1 flex-shrink-0">
                              <p className="text-sm font-black text-blue-600 font-mono">
                                Max: {packagingData.suggestedBox.weight}kg
                              </p>
                              <p className="text-xs text-slate-500 font-medium">
                                Vol:{" "}
                                {parseFloat(
                                  packagingData.suggestedBox.volumetricWeight ||
                                    0,
                                ).toFixed(2)}
                                kg
                              </p>
                            </div>
                          </div>
                        ) : (
                          <div className="border-2 border-dashed border-slate-200 rounded-xl p-4 text-center text-slate-400 text-xs font-semibold bg-slate-50/50">
                            {t("No matching box suggested.")}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right sidebar section */}
          <div className="lg:col-span-4 flex flex-col">
            {/* Completed Packed Stream */}
            <div className="bg-white rounded-2xl shadow-sm border overflow-hidden flex flex-col flex-1 min-h-[400px]">
              <div className="px-5 py-3 border-b bg-slate-50/50 flex flex-col gap-2">
                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse inline-block"></span>
                    <h3 className="font-extrabold text-slate-800 text-[11px] uppercase tracking-wider">
                      Completed Packed Stream
                    </h3>
                  </div>
                  <span className="text-green-700 text-[10px] font-black bg-green-50 px-2 py-0.5 rounded-full border border-green-200">
                    {todayPackedStream.length} {t("Completed")}
                  </span>
                </div>

                {/* Created By Dropdown */}
                <div className="flex items-center justify-between gap-2 mt-1">
                  <span className="text-[10px] font-bold text-slate-500 uppercase tracking-wider shrink-0">
                    Packed By:
                  </span>
                  <select
                    value={selectedStaffId}
                    onChange={(e) => setSelectedStaffId(e.target.value)}
                    className="w-full max-w-[200px] border border-slate-200 rounded-lg px-2.5 py-1 text-xs bg-white text-slate-700 outline-none focus:ring-1 focus:ring-yellow-400 font-semibold"
                  >
                    <option value="all">{t("All Option")}</option>
                    {staffData?.map((staff: any) => (
                      <option key={staff.id} value={staff.id}>
                        {staff.name} ({staff.role})
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="p-4 flex-1 overflow-y-auto max-h-[500px]">
                {todayPackedStream.length === 0 ? (
                  <div className="h-full flex items-center justify-center py-6 text-center">
                    <p className="text-slate-400 text-xs font-semibold">
                      No packages packed today yet.
                    </p>
                  </div>
                ) : (
                  <div className="space-y-2">
                    {todayPackedStream.map((entry: any) => (
                      <div
                        key={entry.awb}
                        className="flex items-center justify-between gap-3 px-3 py-2.5 bg-slate-50 rounded-xl border border-slate-100 hover:border-green-200 hover:bg-green-50/30 transition-all"
                      >
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 mb-1">
                            <span className="font-mono font-black text-[11px] text-slate-800 truncate">
                              {entry.awb}
                            </span>
                            <span className="shrink-0 px-1.5 py-0.5 bg-slate-800 text-[9px] font-bold text-white rounded tracking-wide">
                              {entry.timestamp}
                            </span>
                          </div>
                          {entry.boxName && (
                            <p className="text-[10px] text-slate-500 font-semibold truncate">
                              Box:{" "}
                              <span className="font-bold text-slate-700">
                                {entry.boxName}
                              </span>
                            </p>
                          )}
                          <p className="text-[10px] text-slate-500 font-semibold">
                            Actual Weight:{" "}
                            <span className="font-bold text-slate-700">
                              {parseFloat(String(entry.weight)).toFixed(2)} kg
                            </span>
                          </p>
                          {selectedStaffId === "all" && entry.packedBy && (
                            <p className="text-[9px] text-indigo-600 font-extrabold uppercase mt-0.5">
                              {t("Packed By")}: {entry.packedBy}
                            </p>
                          )}
                        </div>
                        <div className="shrink-0 w-7 h-7 rounded-full bg-green-100 border border-green-200 flex items-center justify-center">
                          <IconCheck
                            size={14}
                            stroke={3}
                            className="text-green-600"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Packed Orders Table underneath */}
      <div className="mt-4  p-2  bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl transition-all duration-300 w-ful rounded-3xl   w-full">
        <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
        <AllOrders
          setHeaderActions={setHeaderActions}
          setHeaderButtons={setHeaderButtons}
          onPackOrder={(awbVal) => {
            setAwbInput(awbVal);
            setAwb(awbVal);
            setIsAwbHighlighted(true);
            setTimeout(() => {
              setIsAwbHighlighted(false);
            }, 1000);
            awbInputRef.current?.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            setTimeout(() => {
              awbInputRef.current?.focus();
            }, 300);
          }}
        />
      </div>

      <LabelPrintModal
        open={showPrintModal}
        onClose={() => setShowPrintModal(false)}
        order={packagingData}
      />

      {isConfirmAllModalOpen && (
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-xs flex items-center justify-center z-[100] p-4">
          <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl overflow-hidden border border-slate-100 animate-in fade-in zoom-in-95 duration-200">
            {/* Header */}
            <div className="px-6 py-4 bg-yellow-50/70 border-b border-yellow-100/50 flex items-center justify-between">
              <div className="flex items-center text-yellow-800 font-extrabold text-sm tracking-wide gap-2">
                <IconAlertTriangle
                  size={18}
                  stroke={2.5}
                  className="text-[#FBD037]"
                />
                <span>{t("CONFIRM INSTANT SCAN ALL")}</span>
              </div>
              <button
                onClick={() => setIsConfirmAllModalOpen(false)}
                className="text-yellow-600 hover:text-yellow-800 transition-colors text-lg font-bold p-1 animate-hover"
              >
                ✕
              </button>
            </div>

            {/* Body */}
            <div className="p-6">
              <p className="text-sm font-semibold text-slate-700 leading-relaxed">                {t("Are you sure you want to instantly verify and pack all items in this order?")}
</p>
            </div>

            {/* Footer */}
            <div className="px-6 py-4 bg-slate-50 border-t border-slate-100 flex items-center justify-end gap-3">
              <button
                type="button"
                onClick={() => setIsConfirmAllModalOpen(false)}
                className="px-5 py-2 border border-slate-200 hover:bg-slate-100 text-slate-600 rounded-xl text-xs font-bold transition duration-150"
              >
                {t("Cancel")}
              </button>
              <button
                type="button"
                onClick={handleConfirmInstantScanAll}
                disabled={instantScanAllMutation.isPending}
                className="px-5 py-2 bg-[#FBD037] hover:bg-yellow-500 text-slate-950 rounded-xl text-xs font-black transition duration-150 shadow-xs disabled:opacity-50"
              >                {instantScanAllMutation.isPending ? t("Packing...") : t("Confirm & Pack")}
</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
